import {useAnankeFlags} from "@vesta/ananke/hooks/useAnankeFlags";

export function useShowErrorFlag() {
    const {showFlag} = useAnankeFlags();

    return (title: string, description?: string) => {
        showFlag({
            title,
            description,
            appearance: "error",
            isAutoDismiss: true,
            autoDismissSeconds: 5,
        });
    };
}
